module.exports = __webpack_public_path__ + "media/packs/images/flags/LK-0f8225576ab510bb3f55d37ca1065414.svg";